import { render, staticRenderFns } from "./Additional-Documents.vue?vue&type=template&id=7ab5e672&scoped=true"
import script from "./Additional-Documents.vue?vue&type=script&lang=js"
export * from "./Additional-Documents.vue?vue&type=script&lang=js"
import style0 from "./Additional-Documents.vue?vue&type=style&index=0&id=7ab5e672&prod&scoped=true&lang=css"
import style1 from "./Additional-Documents.vue?vue&type=style&index=1&id=7ab5e672&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab5e672",
  null
  
)

export default component.exports